import styled from 'styled-components';
import { Form } from '@unform/web';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.25rem;
`;
